export default "__VITE_ASSET__gK9xVjZ8__"